export default {
  path: 'temporary-regulations/requests',
  name: 'TemporaryRegulationsRequests',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RequestsIndex.vue')
}
